import { DateTime, NaiveDate, TimezoneRegion, Utc, Weekday } from "@tento-chrono";

/**
 * Convert an all-day date range to a UTC datetime range.
 * Start is midnight of start date, end is midnight after end date (exclusive).
 */
export function dateRangeToUtcTimeRange(
  dateRange: NaiveDate.Range,
  tz: TimezoneRegion,
): DateTime.Range<Utc> {
  const start = tz.toWallClock(dateRange.start.withTime());
  const end = tz.toWallClock(dateRange.end.add({ days: 1 }).withTime());
  return new DateTime.Range(start, end).toUtc();
}

/**
 * Convert a single date to a UTC datetime range spanning that day.
 * Range is [date 00:00, date+1 00:00) in UTC.
 */
export function dateToUtcDayRange(
  date: NaiveDate,
  tz: TimezoneRegion,
): DateTime.Range<Utc> {
  const start = tz.toWallClock(date.withTime());
  const end = start.add({ days: 1 });
  return new DateTime.Range(start, end).toUtc();
}

/**
 * Days of leading padding for the first week row of a month grid.
 * `firstDayWeekday` is the weekday of the month's first day;
 * `startOfWeek` is the user-configured first day of week.
 */
export function calculateStartPadding(
  firstDayWeekday: Weekday,
  startOfWeek: Weekday,
): number {
  let padding = firstDayWeekday.dow - startOfWeek.dow;
  if (padding < 0) padding += 7;
  return padding;
}
